import { ReactComponent as EyeFilledSvg } from '../../assets/icons/eye-filled.svg';

export const EyeFilledIcon: SvgIcon = (props) => {
    return <EyeFilledSvg {...props} />;
};
